export default class WizardLinesRowData {
    constructor(value) {
        this.chargeType = value.chargeType[0] || "";
        this.brand = value.brand[0] || "";
        this.batchRef = value.batchRef[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
        this.ranumber = value.ranumber[0] || "";
        this.desc = value.desc[0] || "";
        this.locMnemonic = value.locMnemonic[0] || "";
        this.completedRentals = value.completedRentals[0] || "";
        this.noChargeRentals = value.noChargeRentals[0] || "";
        this.voidRentals = value.voidRentals[0] || "";
    }
}